<template>
  <div class="layout-topbar-gran-cliente">
    <button class="p-link layout-menu-button" @click="onMenuToggle">
      <span class="pi pi-bars"></span>
    </button>
    <div class="layout-topbar-icons"></div>
  </div>
</template>

<script>
import MessagesMixin from "@/utils/messages";

export default {
  mixins: [MessagesMixin],

  data() {
    return {};
  },
  methods: {
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
  },
};
</script>